import { ConfigService, PegasusFactory } from '@produce8/pegasus';
import { OrgWorkingDaysPort } from '../../core/application/ports/working-days/org-working-days.port';
import { StaticEnvironmentAdapter } from '../../infrastructure/adapters/environment/static-environment.adapter';
import { UserCountValidationModule } from '../../modules/user-count-validation.module';
import { CubeTimeDimensionGranularity } from '../enum/cube-time-dimension-granularity.enum';
import { StaticEnvironmentKeysEnum } from '../enum/static-environment/static-environment-keys.enum';
import { ValidationFailureException } from '../exceptions/exceptions';
import { CubeRequestConfig } from '../interface/cube-request-config.interface';
import { getPeriodBoundariesFromStartDateAndGranularity } from '../utils/datetime.util';

export interface UserCountInDateRangeParams {
  userIds?: string[];
  startDate: string;
  granularity?: CubeTimeDimensionGranularity;
  endDate?: string;
  departmentId?: string;
}

export interface UserCountInDateRangeProps {
  params: UserCountInDateRangeParams;
  config: CubeRequestConfig;
}

export function GuardvalidateUserCount(value: number) {
  return (
    target: any,
    propertyKey: string,
    descriptor: TypedPropertyDescriptor<(...params: any[]) => Promise<any>>
  ) => {
    const func = descriptor.value!;
    descriptor.value = async function (args: any) {
      try {
        if (value > 0) {
          const { params, config } = args as UserCountInDateRangeProps;
          const app = PegasusFactory.create(UserCountValidationModule, {
            debug: true,
          });
          const configService = app.resolve<ConfigService>(ConfigService);
          configService.set(
            StaticEnvironmentKeysEnum.CUBEJS_API_ENDPOINT,
            StaticEnvironmentAdapter.cubejs_api_endpoint
          );
          if (!params.endDate) {
            const [
              startDate,
              endDate,
              previousPeriodStartDate,
              previousPeriodEndDate,
            ] = getPeriodBoundariesFromStartDateAndGranularity(
              new Date(new Date(params.startDate).setUTCHours(0, 0, 0, 0)),
              params.granularity
            );
            params.endDate = endDate.toISOString().split('T')[0];
          }
          const port = app.resolve<OrgWorkingDaysPort>(OrgWorkingDaysPort);
          const result = await port.userCountInDateRange({ params, config });
          if (result < value) {
            throw new ValidationFailureException(
              'userCount validation check failed.'
            );
          }
        }
        return await func.apply(this, arguments);
      } catch (error) {
        throw new Error(error);
      }
    };
  };
}
